import { render, staticRenderFns } from "./FormEditFranchiseSeo.vue?vue&type=template&id=b85d8da8&scoped=true&"
import script from "./FormEditFranchiseSeo.vue?vue&type=script&lang=js&"
export * from "./FormEditFranchiseSeo.vue?vue&type=script&lang=js&"
import style0 from "./FormEditFranchiseSeo.vue?vue&type=style&index=0&id=b85d8da8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85d8da8",
  null
  
)

export default component.exports